import { render, staticRenderFns } from "./withdraw-form.vue?vue&type=template&id=5a4087c2&scoped=true&"
import script from "./withdraw-form.vue?vue&type=script&lang=js&"
export * from "./withdraw-form.vue?vue&type=script&lang=js&"
import style0 from "./withdraw-form.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./withdraw-form.vue?vue&type=style&index=1&id=5a4087c2&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5a4087c2",
  null
  
)

export default component.exports